export const isCashRewards = (currency: string | undefined): boolean =>
  currency != null && currency.toLocaleLowerCase().includes("cash");
